import React from 'react'
import styled from 'styled-components'
import { motion, AnimatePresence } from 'framer-motion'

const Container = styled.div`
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;

    @media all and (max-width: 480px) {
        bottom: -4rem;
        left: .6rem;
    }
`
const Content = styled(motion.div)`
    width: 90%;
    max-width: var(--content-maxwidth);
    display: flex;
`

const Text = styled.p`
    font-size: .9rem;
`

const variants = {
    initial: {
        opacity: 0,
    },
    animate: {
        opacity: 1,
        transition: {
            duration: .5,
            delay: 1,
        },
    },
    exit: {
        opacity: 0,
    },
}

const Footer = () => {
  return (
    <AnimatePresence>
        <Container>
            <Content
            variants={variants}
            initial="initial"
            animate="animate"
            exit="exit"
            >
                <Text>
                    *Hacemos envíos a todo el país
                </Text>
            </Content>
        </Container>
    </AnimatePresence>
  )
}

export default Footer